import React, { useState, useEffect } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { addQuantityType, updateQuantityType } from '../common/globalapi/Api';

const CreateQuantityType = ({ editData, onClose }) => {
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    const queryClient = useQueryClient();
    const userId = sessionStorage.getItem("userId") || 1; // Fallback to 1 or appropriate default

    const mutation = useMutation({
        mutationFn: (payload) => editData ? updateQuantityType(userId, editData.id, payload) : addQuantityType(payload),
        onSuccess: () => {
            toast.success(editData ? "Quantity Type updated successfully!" : "Quantity Type added successfully!");
            queryClient.invalidateQueries(["quantityTypes", userId]);
            reset();
            // Close the modal programmaticially assuming Bootstrap 5 via ref or dismissal button
            const closeBtn = document.getElementById("closeQuantityTypeModalBtn");
            if (closeBtn) closeBtn.click();
            if (onClose) onClose();
        },
        onError: (error) => {
            toast.error(error?.response?.data || `Failed to ${editData ? 'update' : 'add'} Quantity Type.`);
        }
    });

    useEffect(() => {
        if (editData) {
            setValue("name", editData.name);
        } else {
            reset();
        }
    }, [editData, setValue, reset]);

    const onSubmit = (data) => {
        const payload = {
            registerId: Number(userId),
            name: data.name
        };
        mutation.mutate(payload);
    };

    return (
        <div className="modal fade" id="createQuantityTypeModal" tabIndex="-1" aria-labelledby="createQuantityTypeModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="createQuantityTypeModalLabel">{editData ? 'Edit' : 'Add'} Quantity Type</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeQuantityTypeModalBtn" onClick={onClose}></button>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="quantityTypeName" className="form-label">Quantity Type Name <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    id="quantityTypeName"
                                    placeholder="Enter quantity type (e.g., pieces)"
                                    {...register("name", { required: "Name is required" })}
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name.message}</div>}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={onClose}>Close</button>
                            <button type="submit" className="btn btn-primary" disabled={mutation.isPending}>
                                {mutation.isPending ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateQuantityType;
